export default {
  experimentId: '1',
  serverUrl: 'https://cui-motr-new.herokuapp.com/',
  // serverUrl: 'https://gentle-everglades-00112.herokuapp.com/',
  socketUrl: 'wss://cui-motr-new.herokuapp.com/socket',
  // socketUrl: 'wss://gentle-everglades-00112.herokuapp.com/socket',
  // this will be used in prolific mode
  completionUrl: 'https://app.prolific.co/submissions/complete?cc=C1I4D2OB',
  contactEmail: 'cui.ding@uzh.ch',
  // Either 'debug', 'directLink' or 'prolific'
  mode: 'debug',
  language: 'en'
};